import { searchBox as searchBoxWidget } from "instantsearch.js/es/widgets";

export const searchBoxCatalog = searchBoxWidget({
    container: "[data-widget='searchBox']",
    placeholder: "search catalog...",
    showReset: false,
    cssClasses: {
        input: [
            "focus:outline-none placeholder-blue-400 focus:placeholder-blue-800 " +
                "focus:text-black px-6 py-3 block w-full rounded-full border-none " +
                "bg-white transition ease-in-out duration-150 box-shadow",
        ],
    },
    showSubmit: true,
    templates: {
        submit: `
    `,
    },
});
